import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: "*",
      redirect: "/"
    },
    {
      path: "/",
      name: "PageView",
      component: resolve => require(["@/view/PageView"], resolve),
      children: [
        {
          path: "/",
          redirect: "/home"
        },
        {
          path: "/home",
          name: "home",
          component: resolve => require(["@/view/HomePage"], resolve),
          meta: {
            title: "莲花紫星"
          }
        },
         {
          path: "/jszn",
          name: "jszn",
          component: resolve => require(["@/view/jszn/index"], resolve),
          meta: {
            title: "具身智能"
          }
        },
        {
          path: "/stroage",
          name: "Stroage",
          component: resolve => require(["@/view/products/stroage"], resolve),
          meta: {
            title: "莲花云存储"
          }
        },
        {
          path: "/aitalk",
          name: "aitalk",
          component: resolve => require(["@/view/programme/AiTalk"], resolve),
          meta: {
            title: "对话式AI"
          }
        },
        {
          path: "/aireason",
          name: "aireason",
          component: resolve => require(["@/view/programme/AiReason"], resolve),
          meta: {
            title: "AI推理"
          }
        },
        {
          path: "/finance",
          name: "finance",
          component: resolve => require(["@/view/programme/Finance"], resolve),
          meta: {
            title: "金融服务"
          }
        },
        {
          path: "/energy",
          name: "energy",
          component: resolve => require(["@/view/programme/Energy"], resolve),
          meta: {
            title: "能源电力"
          }
        },
        {
          path: "/dkjj",
          name: "dkjj",
          component: resolve => require(["@/view/programme/Dkjj"], resolve),
          meta: {
            title: "低空经济"
          }
        },
        {
          path: "/zsfa",
          name: "zsfa",
          component: resolve => require(["@/view/programme/Zsfa"], resolve),
          meta: {
            title: "代运营"
          }
        },
        {
          path: "/teach",
          name: "teach",
          component: resolve => require(["@/view/programme/Teach"], resolve),
          meta: {
            title: "高等教育"
          }
        },
        {
          path: "/deeplearn",
          name: "deeplearn",
          component: resolve =>
            require(["@/view/programme/DeepLearn"], resolve),
          meta: {
            title: "深度学习与训练"
          }
        },
        {
          path: "/medical",
          name: "medical",
          component: resolve => require(["@/view/programme/Medical"], resolve),
          meta: {
            title: "医疗健康和生命科学"
          }
        },

        {
          path: "/software",
          name: "software",
          component: resolve => require(["@/view/intro/Software"], resolve),
          meta: {
            title: "业务介绍-莲花紫星"
          },
          children: []
        },
        {
          path: "/newsinformation",
          name: "newsinformation",
          component: resolve =>
            require(["@/view/intro/NewsInformation"], resolve),
          meta: {
            title: "公司动态-莲花紫星"
          }
        },
        {
          path: "/newsdetail",
          name: "newsdetail",
          component: resolve => require(["@/view/intro/NewsDetail"], resolve),
          meta: {
            title: "新闻详情-莲花紫星"
          }
        },
        {
          path: "/companyintroduction",
          name: "companyintroduction",
          component: resolve =>
            require(["@/view/intro/CompanyIntroduction"], resolve),
          meta: {
            title: "合作伙伴-莲花紫星"
          }
        },
        {
          path: "/jobchance",
          name: "jobchance",
          component: resolve => require(["@/view/intro/JobChance"], resolve),
          meta: {
            title: "招聘中心-莲花紫星"
          }
        },
        {
          path: "/joinus",
          name: "joinus",
          component: resolve => require(["@/view/intro/JoinUs"], resolve),
          meta: {
            title: "加入我们-莲花紫星"
          }
        },
        {
          path: "/contactus",
          name: "contactus",
          component: resolve => require(["@/view/intro/ContactUs"], resolve),
          meta: {
            title: "关于我们-莲花紫星"
          }
        },
        {
          path: "/jobDetails",
          name: "jobDetails",
          component: resolve =>
            require(["@/view/intro/JobDetails.vue"], resolve),
          meta: {
            title: "岗位详情-莲花紫星"
          }
        },
        {
          path: "/help",
          name: "help",
          component: resolve => require(["@/view/help/index"], resolve),
          meta: {
            title: "帮助中心"
          }
        },
        {
          path: "/link",
          name: "link",
          component: resolve => require(["@/view/other/link"], resolve),
          meta: {
            title: "企业微信"
          }
        },
        {
          path: "/zxjobchance",
          name: "zxjobchance",
          component: resolve => require(["@/view/zxJob/JobChance"], resolve),
          meta: {
            title: "招贤纳士-莲花紫星"
          }
        },
        {
          path: "/zxjobDetails",
          name: "zxjobDetails",
          component: resolve =>
            require(["@/view/zxJob/JobDetails.vue"], resolve),
          meta: {
            title: "岗位详情"
          }
        },
        {
          path: "/zxcompany",
          name: "zxcompany",
          component: resolve =>
            require(["@/view/wx/CompanyIntro.vue"], resolve),
          meta: {
            title: "生态合作"
          }
        },
        {
          path: "/app-private",
          name: "app-private",
          component: resolve => require(["@/view/app/private.vue"], resolve),
          meta: {
            title: "隐私协议"
          }
        },
        {
          path: "/app-user-private",
          name: "app-user-private",
          component: resolve => require(["@/view/app/user-private.vue"], resolve),
          meta: {
            title: "用户协议"
          }
        },
        {
          path: "/download",
          name: "download",
          component: resolve => require(["@/view/app/downloadlink.vue"], resolve),
          meta: {
            title: "下载-莲花紫星"
          }
        },
        {
          path: "/lotus-api-docs",
          alias: "/lotus_api_docs",
          name: "lotus-api-docs",
          component: resolve => require(["@/view/app/LotusApiDocs.vue"], resolve),
          meta: {
            title: "Lotus_api聚合平台 - 配置文档"
          }
        },
        {
          path: "/token-factory",
          name: "token-factory",
          component: resolve => require(["@/view/app/TokenFactory.vue"], resolve),
          meta: {
            title: "token工厂-莲花紫星"
          }
        },
        {
          path: "/lotus-box",
          name: "lotus-box",
          component: resolve => require(["@/view/app/LotusBox.vue"], resolve),
          meta: {
            title: "莲小盒-莲花紫星"
          }
        },
        {
          path: "/lotus-ring",
          name: "lotus-ring",
          component: resolve => require(["@/view/app/LotusRing.vue"], resolve),
          meta: {
            title: "Lotus Ring智能戒指-莲花紫星"
          }
        },
        {
          path: "/redeem-code",
          name: "redeem-code",
          component: resolve => require(["@/view/app/RedeemCode.vue"], resolve),
          meta: {
            title: "兑换码-莲花紫星"
          }
        },
        {
          path: "/video-generation",
          name: "video-generation",
          component: resolve => require(["@/view/app/VideoGeneration.vue"], resolve),
          meta: {
            title: "莲花紫星AI视频生成平台"
          }
        }
      ]
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js